import { select } from 'redux-saga/effects'

import Zoid from 'common/modules/zoid'

export default function* watchLinkPassed({ payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)

    sendHostMessage('EXTERNAL/LINK', payload)
}
